import React from 'react';
import { Page } from '../Page';
import { Droplet, Eye, Brain, Info, AlertCircleIcon } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page7() {
  return <Page pageNumber={18} variant="light" data-id="element-836">
      <div className="flex flex-col h-full" data-id="element-837">
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-838">
          <img src="https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=1000&q=80" alt="Fresh salmon and omega-3 rich foods" className="w-full h-full object-cover" data-id="element-839" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-840" />
        </div>

        <div className="mb-8 pt-4" data-id="element-841">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-842">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-843">
            Omega-3 <span className="text-tealslate" data-id="element-844">Fatty Acids</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-845" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-846">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-847">
            Omega-3s are essential fats your body cannot produce on its own.
            While they are important for everyone, they play a specific and
            critical role when you are taking GLP-1 medication.
          </p>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-848">
            <div className="flex items-center gap-2 mb-2" data-id="element-849">
              <Info className="w-4 h-4 text-tealslate" data-id="element-850" />
              <h3 className="font-bold text-[#1F1F1F] text-xs" data-id="element-851">
                What About ALA?
              </h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-852">
              ALA (found in flaxseed, chia, walnuts) converts poorly to EPA and
              DHA. ALA-only supplements are an unreliable way to meet your
              omega-3 needs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-5 mb-8" data-id="element-853">
          {[{
          icon: Droplet,
          title: 'Elevated Triglycerides',
          text: 'Omega-3s have a well-established lowering effect.'
        }, {
          icon: Eye,
          title: 'Dry Eyes & Skin',
          text: 'Supports retinal structure and skin barrier function.'
        }, {
          icon: Brain,
          title: 'Mental Fatigue',
          text: 'Low intake may contribute to brain fog.'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-854">
              <div className="w-12 h-12 rounded-full bg-tealslate/15 border border-tealslate/30 flex items-center justify-center mx-auto mb-3" data-id="element-855">
                <item.icon className="w-5 h-5 text-tealslate" data-id="element-856" />
              </div>
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-857">
                {item.title}
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-relaxed" data-id="element-858">
                {item.text}
              </p>
            </div>)}
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-859">
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-860">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-861">
              Fishy Burps
            </h3>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-862">
              <strong data-id="element-863">Enteric-coated</strong> capsules dissolve in the intestine
              instead of the stomach, reducing this common side effect.
            </p>
          </div>
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-864">
            <div className="flex items-center gap-2 mb-1" data-id="element-865">
              <AlertCircleIcon className="w-3.5 h-3.5 text-[#C4956A]" data-id="element-866" />
              <h3 className="font-bold text-[#1F1F1F] text-xs" data-id="element-867">Safety</h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B] leading-[1.7]" data-id="element-868">
              Taking high doses with blood thinners may increase bleeding risk.
              Stay within <strong data-id="element-869">250-500 mg per day</strong>.
            </p>
          </div>
        </div>

        <SupplementCallout title="Fish Oil" description="If you do not eat fatty fish 2-3 times per week, a fish oil supplement providing 250-500mg combined EPA and DHA is recommended." data-id="element-870" />
      </div>
    </Page>;
}